import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import convertToNestedArray from "@sourceflow-uk/functions/convertToNestedArray";
import data from "@sourceflow/footer_menu.json";

export const useFooterMenu = () => convertToNestedArray(useSourceFlowCollection(data));

export default useFooterMenu;
